import { tokens } from '@cast/design-system';
import { ClusterReliabilityMetrics } from '@cast/types';

export type ReliabilityMetricKey = keyof Omit<
  ClusterReliabilityMetrics,
  'noDataReason'
>;

type ReliabilityChartGroup = 'traffic' | 'latency';

export type ReliabilityMetricConfig = {
  key: ReliabilityMetricKey;
  label: string;
  unit: string;
  stroke: string;
  chartGroup: ReliabilityChartGroup;
};

export const RELIABILITY_METRICS: ReliabilityMetricConfig[] = [
  {
    key: 'requestRate',
    label: 'Request rate',
    unit: 'req/s',
    stroke: tokens.theme.data.aqua700,
    chartGroup: 'traffic',
  },
  {
    key: 'errorRate',
    label: 'Error rate',
    unit: 'req/s',
    stroke: tokens.theme.data.red500,
    chartGroup: 'traffic',
  },
  {
    key: 'latencyP50',
    label: 'Latency p50',
    unit: 'ms',
    stroke: tokens.theme.data.blue500,
    chartGroup: 'latency',
  },
  {
    key: 'latencyP95',
    label: 'Latency p95',
    unit: 'ms',
    stroke: tokens.theme.data.indigo500,
    chartGroup: 'latency',
  },
  {
    key: 'latencyP99',
    label: 'Latency p99',
    unit: 'ms',
    stroke: tokens.theme.data.yellow400,
    chartGroup: 'latency',
  },
];
